import { SVGProps } from "react";

const LightningSvg = ({
  color = "#F8AD21",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.967 3L4.75 14H12L11.033 21L19.25 10H12L12.967 3Z"
      stroke={color}
      fill={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LightningSvg;
